import type { Role } from "../api/types";

/**
 * Basit RBAC matrisi (§9: admin tam, operator cihaz+uyarı yanıtlama,
 * viewer salt okunur). Backend RBAC ile aynı sözlüğü kullanır.
 */
export type Permission =
  | "view"
  | "manageDevices"
  | "ackAlerts"
  | "manageAlertRules"
  | "manageSnmp"
  | "manageUsers"
  | "manageEnrollment";

const rolePermissions: Record<Role, readonly Permission[]> = {
  admin: [
    "view",
    "manageDevices",
    "ackAlerts",
    "manageAlertRules",
    "manageSnmp",
    "manageUsers",
    "manageEnrollment",
  ],
  operator: ["view", "manageDevices", "ackAlerts", "manageAlertRules"],
  viewer: ["view"],
};

export function can(role: Role | undefined, permission: Permission): boolean {
  if (!role) return false;
  return rolePermissions[role].includes(permission);
}

export function hasAnyRole(role: Role | undefined, allowed: readonly Role[]): boolean {
  return role !== undefined && allowed.includes(role);
}